import { useState, useEffect } from "react";
import UserInviteModal from "../../components/user/UserInviteModal";
import { useTeamsQuery } from "../../Services/settingsAPIs/CommonAPI";
import {
  useActiveUserQueryDownloadQuery,
  useActiveUserQueryQuery,
  useReleaseSessionQuery,
} from "../../Services/user/Users";
import ReactModal from "react-modal";
import DeleteUserModal from "../../components/user/DeleteUserModal";
import EditUserModal from "../../components/user/EditUserModal";
import ResetPasswordModal from "../../components/user/ResetPasswordModal";
import AccountDeactivateModal from "../../components/user/AccountDeactivateModal";
import Activate from "./Activate";
import Deactivate from "./Deactivate";
import SortingTableUsers from "../../components/reusableComponent/SortingTableUsers";
import { formatDate } from "../../components/reusableComponent/DateFormat";
import "./styles.scss";
import { ACTIVITY_PRIMARY, activityToolbarOutlinedSx } from "../activity/activityUiTokens";
import * as XLSX from "xlsx";
import { Button, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import LoadingSpinner from "../../components/LoadingSpinner";
import ActiveUserFilterModal from "./ActiveUserFilterModal";
import { useNavigate } from "react-router-dom";
import { Loader } from "react-bootstrap-typeahead";
import { Modal } from "react-bootstrap";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "80%",
    maxWidth: "850px", // Max width for larger screens
    margin: "auto",
    Overflow: "hidden",
    OverflowY: "auto",
  },
};

const customEditModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "1150px", // Max width for larger screens
    height: "80%",
    margin: "auto",
    Overflow: "hidden",
    OverflowY: "auto",
  },
};

const customBulkModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "400px", // Max width for larger screens
    margin: "auto",
    Overflow: "hidden",
    OverflowY: "auto",
  },
};

const customResetPassModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "450px", // Max width for larger screens
    margin: "auto",
    Overflow: "hidden",
    OverflowY: "auto",
  },
};

const DeleteModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "2px solid #dde",
    width: "90%",
    maxWidth: "400px",
    margin: "auto",
    Overflow: "hidden",
    OverflowY: "auto",
  },
};

const UserPage = () => {
  const isSmallScreen = useMediaQuery("(max-width:825px)");
  const isExtraSmallScreen = useMediaQuery("(max-width:730px)");
  
  const cardsData = [
    // { label: "Sr no.", key: "Sr no." },
    { label: "User", key: "User" },
    { label: "User id", key: "UserId" },
    { label: "Created date", key: "Created Date" },
    { label: "Last updated date", key: "Last updated date" },
    { label: "Role", key: "Role" },
    { label: "Branch user", key: "Branch" },
  ];

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEnabled, setisEnabled] = useState<boolean>(true);
  const [isBulk, setIsBulk] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] =
    useState<boolean>(false);

  const [isAccountDeactivate, setIsAccountDeactivate] =
    useState<boolean>(false);

  const [theTeams, setTheTeams] = useState([]);
  const [getUsersData, setGetUsersData] = useState<any>([]);
  const [selectedTeam, setSelectedTeam] = useState<any>();
  const { data: teamsData } = useTeamsQuery({});

  const [selectedEditId, setSelectedEditId] = useState();
  const [selectedDeleteId, setSelectedDeleteId] = useState();
  const [selectedReleaseId, setSelectedReleaseId] = useState();

  // Separate pagination states for Active and Deactive
  const [activeCurrentPage, setActiveCurrentPage] = useState(1);
  const [activeTotalPages, setActiveTotalPages] = useState(1);
  const [activePageSize, setActivePageSize] = useState(10);

  const [deactiveCurrentPage, setDeactiveCurrentPage] = useState(1);
  const [deactiveTotalPages, setDeactiveTotalPages] = useState(1);
  const [deactivePageSize, setDeactivePageSize] = useState(10);

  const [liftingColumn, setLiftingColumn] = useState("");
  const [liftingActiveUserFilterData, setLiftingActiveUserFilterData] =
    useState<any>({});
  const [isAccountFilterModalOpen, setIsAccountFilterIsModalOpen] =
    useState<boolean>(false);
  const [accountDownloadButtonClicked, setAccountDownloadButtonClicked] =
    useState<boolean>(false);
  const [accountDownloadedData, setAccountDownloadedData] = useState<any>([]);
  const [accountDownloadLoading, setAccountDownloadLoading] =
    useState<boolean>(false);
  const [userLoading, setUserLoading] = useState(false);

  // states for success modal and info
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [inviteInfo, setInviteInfo] = useState({ username: "", password: "" });

  // Use appropriate page states based on isEnabled
  const currentPage = isEnabled ? activeCurrentPage : deactiveCurrentPage;
  const totalPages = isEnabled ? activeTotalPages : deactiveTotalPages;
  const pageSize = isEnabled ? activePageSize : deactivePageSize;
  const setCurrentPage = isEnabled
    ? setActiveCurrentPage
    : setDeactiveCurrentPage;
  const setPageSize = isEnabled ? setActivePageSize : setDeactivePageSize;

  const {
    data: sortData,
    isLoading: sortingLoading,
    refetch,
    status: usersLoading,
  } = useActiveUserQueryQuery(
    {
      page: currentPage,
      pageSize,
      sort: liftingColumn,
      selectedTeam: selectedTeam || "", // use undefined if selectedTeam is falsy
      liftingActiveUserFilterData,
      isEnabled,
    },
    {
      skip: !liftingColumn,
    }
  );

  const { data: downloadAccountData, status: downloadAccountStatus } =
    useActiveUserQueryDownloadQuery(
      {
        page: currentPage,
        sort: liftingColumn,
        liftingActiveUserFilterData,
        accountDownloadButtonClicked,
        selectedTeam: selectedTeam || "",
        isEnabled,
      },
      { skip: !accountDownloadButtonClicked }
    );

  useEffect(() => {
    if (usersLoading === "pending") {
      setUserLoading(true);
    } else {
      setUserLoading(false);
    }
  }, [usersLoading]);

  useEffect(() => {
    if (usersLoading === "fulfilled" && sortData) {
      setGetUsersData(sortData?.results);

      // Update the appropriate total pages based on current mode
      if (isEnabled) {
        setActiveTotalPages(Math.ceil(sortData.count / activePageSize));
      } else {
        setDeactiveTotalPages(Math.ceil(sortData.count / deactivePageSize));
      }
    }
  }, [sortData, usersLoading, isEnabled, activePageSize, deactivePageSize]);

  useEffect(() => {
    if (downloadAccountStatus === "pending") {
      setAccountDownloadLoading(true);
      setAccountDownloadButtonClicked(true);
    } else {
      setAccountDownloadLoading(false);
    }
  }, [downloadAccountStatus]);

  useEffect(() => {
    if (downloadAccountStatus === "fulfilled" && downloadAccountData) {
      setAccountDownloadedData(downloadAccountData);
    }
  }, [downloadAccountData, downloadAccountStatus]);

  useEffect(() => {
    if (
      downloadAccountStatus === "fulfilled" &&
      accountDownloadButtonClicked &&
      accountDownloadedData?.length >= 0
    ) {
      setAccountDownloadButtonClicked(false);

      setAccountDownloadLoading(false);
      downloadAccountsData();
    }
  }, [
    downloadAccountStatus,
    accountDownloadButtonClicked,
    accountDownloadedData,
  ]);

  const handleFirstDropdownChange = (event: any) => {
    setSelectedTeam(Number.parseInt(event.target.value));
  };

  const downloadAccountsData = async () => {
    setAccountDownloadLoading(true);
    setAccountDownloadButtonClicked(true);

    if (accountDownloadedData && accountDownloadedData.length > 0) {
      const csvData = accountDownloadedData?.map((user) => ({
        User: user.username,
        "User id": user.id,
        "Created date": user.created ? formatDate(user.created) : "",
        "Last updated date": user.last_updated
          ? formatDate(user.last_updated)
          : "",
        Role: user.role,
        "Branch user": user.branch_user ? "Yes" : "No",
      }));

      const worksheet = XLSX.utils.json_to_sheet(csvData);

      const csvOutput = XLSX.utils.sheet_to_csv(worksheet);

      const blob = new Blob([csvOutput], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        isEnabled ? "Active_User_data.csv" : "Deactive_User_data.csv"
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setAccountDownloadLoading(false);
      setAccountDownloadButtonClicked(false);
      setAccountDownloadedData([]);
    } else {
      setAccountDownloadLoading(false);
    }
  };

  const { data: releaseSession } = useReleaseSessionQuery(selectedReleaseId, {
    skip: !selectedReleaseId,
  });

  const handleReleaseSessionClick = (userId: any) => {
    setSelectedReleaseId(userId);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const getInitials = (name: string) => {
    if (!name) return "";
    const nameParts = name.split(" ");
    if (nameParts.length === 1) return nameParts[0].charAt(0).toUpperCase();
    return (
      nameParts[0].charAt(0).toUpperCase() +
      nameParts[1].charAt(0).toUpperCase()
    );
  };

  const getRandomColor = () => {
    const colors = [
      "bg-users-primary",
      "bg-success",
      "bg-danger",
      "bg-warning",
      "bg-dark",
    ];
    // Create a Uint32Array with a single element
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    const randomIndex = array[0] % colors.length;
    return colors[randomIndex];
  };

  const handleToggleActivate = () => {
    setisEnabled(!isEnabled);
  };

  useEffect(() => {
    if (teamsData) {
      setTheTeams(teamsData);
    }
  }, [teamsData]);

  const openAccountsFilterModal = () => {
    setIsAccountFilterIsModalOpen(true);
  };

  const closeAccountsFilterModal = () => {
    setIsAccountFilterIsModalOpen(false);
  };

  const openEditModal = () => {
    setIsEditModalOpen(true);
  };

  const afterOpenEditModal = () => {};

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const afterOpenDeleteModal = () => {};

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const openResetPasswordModal = () => {
    setIsResetPasswordModalOpen(true);
  };

  const afterOpenResetPasswordModal = () => {};

  const closeResetPasswordModal = () => {
    setIsResetPasswordModalOpen(false);
  };

  const openAccountDeactivateModal = () => {
    setIsAccountDeactivate(true);
  };

  const afterAccountDeactivateModal = () => {};

  const closeAccountDeactivateModal = () => {
    setIsAccountDeactivate(false);
  };

  const isEditModal = (data: any) => {
    setSelectedEditId(data);
    openEditModal();
  };

  const isDeleteModal = (data: any) => {
    setSelectedDeleteId(data);
    openDeleteModal();
  };

  const isResetPassModal = (data: any) => {
    setSelectedDeleteId(data);
    openResetPasswordModal();
  };

  const isDeactivateAccountModal = (data: any) => {
    setSelectedDeleteId(data);
    openAccountDeactivateModal();
  };

  const closeSuccessModal = () => {
    setSuccessModalVisible(false);
  };

  const capitalizeFirstLetter = (str: string) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const customFilterModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%", // Default to full width
      maxWidth: "30%",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  useEffect(() => {
    setLiftingActiveUserFilterData({
      name: "",
    });
  }, [isEnabled]);

  const navigate = useNavigate(); // Initialize useNavigate
  const handleBackButtonClick = () => {
    navigate(-1);
  };

  // Callback to be passed to UserInviteModal
  const handleInviteSuccess = (info) => {
    setIsModalOpen(false); // Close invite modal
    setInviteInfo(info);
    setTimeout(() => setSuccessModalVisible(true), 300); // Show success modal
  };

  return (
    <div className="custom-style">
      <div id="kt_app_content_container" className="app-container">
        <div className="card card-flush">
          <div className="card-header align-items-center py-1 gap-2 gap-md-5">
            <div className="d-flex">
              <button
                className="btn btn-link mb-2"
                onClick={handleBackButtonClick}
              >
                <i
                  className="bi bi-arrow-90deg-left"
                  style={{
                    fontSize: "20px",
                    color: "black",
                    cursor: "pointer",
                  }}
                ></i>
              </button>
              <h2 className="p-4">Users</h2>
            </div>
            <div>
              {isEnabled ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Tooltip title="Download Active Data">
                    <IconButton
                      onClick={() => {
                        setAccountDownloadButtonClicked(true);

                        downloadAccountsData();
                      }}
                    >
                      {accountDownloadLoading ? (
                        <Loader />
                      ) : (
                        <i
                          className="bi bi bi-download"
                          style={{
                            fontSize: "25px",
                            color: "black",
                          }}
                        ></i>
                      )}
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Tooltip title="Download Deactive Data">
                    <IconButton
                      onClick={() => {
                        setAccountDownloadButtonClicked(true);

                        downloadAccountsData();
                      }}
                    >
                      {accountDownloadLoading ? (
                        <Loader />
                      ) : (
                        <i
                          className="bi bi bi-download"
                          style={{
                            fontSize: "25px",
                            color: "black",
                          }}
                        ></i>
                      )}
                    </IconButton>
                  </Tooltip>
                </div>
              )}
            </div>
          </div>

          <div
            className={`row ${isExtraSmallScreen ? "flex-column gap-3" : ""}`}
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {/* Filter and Team */}
            <div
              className={`d-flex align-items-center gap-3 ${isExtraSmallScreen ? "w-100 justify-content-center" : ""}`}
              style={{
                marginLeft: isExtraSmallScreen ? "7px" : "25px",
                width: isExtraSmallScreen ? "100%" : "40%",
                display: "flex",
                gap: "10px",
              }}
            >
              <Button
                variant="outlined"
                className="fw-bold"
                onClick={openAccountsFilterModal}
                sx={{
                  ...activityToolbarOutlinedSx,
                  height: isSmallScreen ? 35 : 40,
                  width: isExtraSmallScreen ? "100%" : isSmallScreen ? 140 : "auto",
                  minWidth: isSmallScreen ? "140px" : "150px",
                  gap: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingRight: "0px",
                  paddingLeft: "0px",
                  fontSize: isSmallScreen ? "12px" : "14px",
                }}
              >
                <i className="bi bi-filter fs-2" style={{ color: ACTIVITY_PRIMARY }} />
                <span
                  className="me-2"
                  style={{
                    fontSize: isSmallScreen ? "12px" : "14px",
                    whiteSpace: "nowrap",
                    textTransform: "none",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "flex-start",
                    color: ACTIVITY_PRIMARY,
                  }}
                >
                  Search filter
                </span>
              </Button>
              <div className={`${isExtraSmallScreen ? "w-100" : "min-w-150px"}`}>
                <select
                  className="form-select select2-hidden-accessible"
                  onChange={handleFirstDropdownChange}
                  style={{
                    height: isSmallScreen ? 35 : 40,
                    fontSize: isSmallScreen ? "12px" : "14px",
                  }}
                >
                  <option value="" selected disabled>
                    Select team
                  </option>
                  {theTeams &&
                    theTeams?.map((team, index) => (
                      <option key={index} value={team.id}>
                        {team?.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div
              className={`d-flex align-items-center justify-content-end ${isExtraSmallScreen ? "w-100" : ""}`}
              style={{
                display: "flex",
                justifyContent: "end",
                flex: "1",
                marginLeft: isExtraSmallScreen ? "7px" : "0px",
                gap: isSmallScreen ? "10px" : "50px",
              }}
            >
              <div className="d-flex align-items-center justify-content-end mt-2 mt-md-0">
                <label
                  className="form-check-label mx-2"
                  style={{ 
                    whiteSpace: "nowrap",
                    fontSize:  isSmallScreen ? "12px" : "14px",
                  }}
                >
                  Active users
                </label>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={!isEnabled}
                    onChange={handleToggleActivate}
                  />
                  <label 
                    className="card-text" 
                    style={{ 
                      whiteSpace: "nowrap",
                      fontSize: isSmallScreen ? "12px" : "14px",
                    }}
                  >
                    Deactivated users
                  </label>
                </div>
              </div>

              
                <button
                  className={`btn btn-users-primary form-control align-items-center fw-bold ${isExtraSmallScreen ? "w-50" : "w-150px"}`}
                  style={{
                    height: isSmallScreen ? 35 : 40,
                    fontSize: isSmallScreen ? "12px" : "14px",
                  }}
                  onClick={openModal}
                >
                  <i className={`bi bi-person-plus me-2 text-light ${isSmallScreen ? "fs-5" : "fs-3"}`}></i>
                  <span className="ms-auto fw-bold ">Add user</span>
                </button>
                <ReactModal
                  isOpen={isModalOpen}
                  onRequestClose={closeModal}
                  style={!isBulk ? customModalStyles : customBulkModalStyles}
                  contentLabel="New Ticket"
                  shouldCloseOnOverlayClick={false}
                >
                  <UserInviteModal
                    closeModal={closeModal}
                    isBulk={isBulk}
                    setIsBulk={setIsBulk}
                    refetch={refetch}
                    onSuccess={handleInviteSuccess} // Pass callback
                  />
                </ReactModal>
                          

              <Modal
                show={successModalVisible}
                onHide={closeSuccessModal}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Help desk</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>
                    <strong>Your username:</strong> {inviteInfo.username}
                  </p>
                  <p>
                    <strong>Default password for first time login:</strong>{" "}
                    {inviteInfo.password}
                  </p>
                  <p>
                    Please log in using this default password and update it
                    immediately after your first login.
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="contained"
                    onClick={closeSuccessModal}
                    sx={{
                      bgcolor: "#6366f1",
                      textTransform: "none",
                      boxShadow: "none",
                      "&:hover": { bgcolor: "#4f46e5", boxShadow: "none" },
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>

          <div className="row gap-5 ms-3 mb-2" style={{ marginTop: "20px" }}>

            {/* Scrollable content with full available height */}
            {/* <div style={{ overflow: "auto", height: "calc(100vh - 300px)" }}> */}
            {isEnabled ? (
              <Activate
                usersData={getUsersData}
                currentPage={activeCurrentPage}
                setCurrentPage={setActiveCurrentPage}
                totalPages={activeTotalPages}
                sortingLoading={sortingLoading}
                getRandomColor={getRandomColor}
                getInitials={getInitials}
                capitalizeFirstLetter={capitalizeFirstLetter}
                formatDate={formatDate}
                isResetPassModal={isResetPassModal}
                isEditModal={isEditModal}
                isDeleteModal={isDeleteModal}
                isDeactivateAccountModal={isDeactivateAccountModal}
                handleReleaseSessionClick={handleReleaseSessionClick}
                usersLoading={userLoading}
                pageSize={activePageSize}
                setPageSize={setActivePageSize}
                setLiftingColumn={setLiftingColumn}
              />
            ) : (
              <Deactivate
                getRandomColor={getRandomColor}
                getInitials={getInitials}
                capitalizeFirstLetter={capitalizeFirstLetter}
                totalPages={deactiveTotalPages}
                refetch={refetch}
                getDeactiveUsersData={getUsersData}
                formatDate={formatDate}
                deactiveCurrentPage={deactiveCurrentPage}
                setCurrentPage={setDeactiveCurrentPage}
                usersLoading={userLoading}
                sortingLoading={sortingLoading}
                pageSize={deactivePageSize}
                setPageSize={setDeactivePageSize}
                currentPage={currentPage}
                setLiftingColumn={setLiftingColumn}
              />
            )}
          </div>
          {/* </div> */}

          <ReactModal
            isOpen={isEditModalOpen}
            onAfterOpen={afterOpenEditModal}
            onRequestClose={closeEditModal}
            style={customEditModalStyles}
            contentLabel="Edit User"
            shouldCloseOnOverlayClick={false}
          >
            <EditUserModal
              closeEditModal={closeEditModal}
              user={selectedEditId}
              refetch={refetch}
            />
          </ReactModal>
          <ReactModal
            isOpen={isDeleteModalOpen}
            onAfterOpen={afterOpenDeleteModal}
            onRequestClose={closeDeleteModal}
            style={DeleteModalStyles}
            contentLabel="delete User"
            shouldCloseOnOverlayClick={false}
          >
            <DeleteUserModal
              closeDeleteModal={closeDeleteModal}
              userData={selectedDeleteId}
              refetch={refetch}
            />
          </ReactModal>

          <ReactModal
            isOpen={isResetPasswordModalOpen}
            onAfterOpen={afterOpenResetPasswordModal}
            onRequestClose={closeResetPasswordModal}
            style={customResetPassModalStyles}
            contentLabel="reset password"
            shouldCloseOnOverlayClick={false}
          >
            <ResetPasswordModal
              closeResetPasswordModal={closeResetPasswordModal}
              resetPass={selectedDeleteId}
              refetch={refetch}
            />
          </ReactModal>

          <ReactModal
            isOpen={isAccountDeactivate}
            onAfterOpen={afterAccountDeactivateModal}
            onRequestClose={closeAccountDeactivateModal}
            style={DeleteModalStyles}
            contentLabel="deactivate account"
            shouldCloseOnOverlayClick={false}
          >
            <AccountDeactivateModal
              closeAccountDeactivateModal={closeAccountDeactivateModal}
              user={selectedDeleteId}
              refetch={refetch}
            />
          </ReactModal>

          <ReactModal
            isOpen={isAccountFilterModalOpen}
            onRequestClose={closeAccountsFilterModal}
            style={customFilterModalStyles}
            contentLabel="Ticket Filter Modal"
            shouldCloseOnOverlayClick={false}
          >
            <ActiveUserFilterModal
              closeFilterModal={closeAccountsFilterModal}
              setLiftingContactFilterData={setLiftingActiveUserFilterData}
              setPage={setCurrentPage}
              contactDataa={getUsersData}
              liftingContactFilterData={liftingActiveUserFilterData}
            />
          </ReactModal>
        </div>
      </div>
    </div>
  );
};

export default UserPage;